import React, { useState } from "react";
import { motion } from "framer-motion";
import "./Muay.css";

const Muay = () => {
  const highlights = [
    {
      media: "/images/fight-highlight/fight2.jpg",
      description: "First fight in ATV ",
    },
    {
      media: "/images/fight-highlight/fight3.jpg",
      description: "Knockout Knee",
    },
    {
      media: "/images/fight-highlight/thai1.jpg",
      description: "Training in Bangkok",
    },
    {
      media: "/images/fight-highlight/thai2.jpg",
      description: "2 weeks survival",
    },
    {
      media: "/images/fight-highlight/fight4_1.jpg",
      description: "WIN!",
    },
    {
      media: "/images/fight-highlight/blood.jpg",
      description: "...",
    },
  ];

  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (media) => {
    setSelectedImage(media);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div id="muay-thai-container" className="p-2 md:ml-12 pb-8">
      <h4 className="text-md md:text-xl tracking-[4px] underline underline-offset-4 font-semibold mb-10">
        Muay Thai
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-3 sm:gap-4">
        {highlights.map((highlight, index) => (
          <motion.div
            key={index}
            whileHover={{
              scale: 1.05,
              transition: { duration: 0.1 },
            }}
            className="glass p-4 rounded-md"
            onClick={() => openModal(highlight.media)}
          >
            <img
              src={highlight.media}
              alt={highlight.date}
              className="w-full h-[250px] object-cover rounded-md cursor-pointer"
            />
            <p className="text-neutral-500 pt-4 sm:py-4 text-center text-[12px] md:text-[16px]">
              {highlight.description}
            </p>
          </motion.div>
        ))}
      </div>
      {selectedImage && (
        <div
          id="pop-screen"
          className="visible fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-75 z-50"
        >
          <div className="absolute">
            <div className="w-[45vw] h-[45vw] max-w-screen-md max-h-screen-3/4 overflow-auto rounded-lg flex justify-center items-center">
              <img
                src={selectedImage}
                alt="Selected"
                className="max-w-full max-h-full object-cover rounded-xl"
              />
            </div>
          </div>
          <button
            className="absolute top-4 right-4 p-2 bg-opacity-50 text-white hover:text-[#7562E0]"
            onClick={closeModal}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default Muay;
